import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d36b279c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trial-expired-modal__text mb-3" }, " Пробный период закончился, вам доступно 3 ученика, чаты, учет финансов, добавление своих материалов. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "trial-expired-modal__accent mb-3" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Если у вас добавлено более 3 учеников, ученики сверх лимита будут автоматически перемещены в архив."),
  /*#__PURE__*/_createElementVNode("li", null, "Все созданные доски сохранятся в материалах, но доступ к ним будет ограничен до подключения опции «Онлайн-доска»."),
  /*#__PURE__*/_createElementVNode("li", null, "Без подключения опции «Звонки» проведение онлайн-занятий будет недоступно.")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trial-expired-modal__text" }, " Выбирайте удобный набор возможностей и оплачивайте только то, чем пользуетесь. ", -1))

import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrialExpiredModal',
  emits: ["hidden", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = __emit;

function onConfirm() {
    emit('confirm');
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Формируете свой тариф самостоятельно",
    onButtonClick: onConfirm,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    "button-text": "Оформить подписку",
    "max-width": 450
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 512))
}
}

})